export interface BathcFileDetailsTypes {
  docType: string | null;
  fileName: string | null;
  pageCount: number;
  username: string | null;
  processStartDate: string | null;
  processEndDate: string | null;
  elapsedTime: string | null;
  statusName: string | null;
  fileID: number;
  batchID: string;
  parentBatchID?: string;
}

interface BathcFileDetailsTypesWithSubRows extends BathcFileDetailsTypes {
  subRows?: BathcFileDetailsTypes[];
}

export interface PredictionBatchDetailsType extends BathcFileDetailsTypes {
  // batchID: string;
  requestID: number;
  batchName: string;
  batchPath: string | null;
  batchPreprocessPath: string | null;
  docTypeID: number;
  processID: number;
  userName: string;
  clientName: string;
  deptName: string;
  fileCount: number;
  batchStatus: string;
  processStartDate: string;
  processEndDate: string;
  qcStartDate: string;
  qcEndDate: string;
  entryBy: number;
  processName: string;
  docType: string;
  systemName: string | null;
  batchTypeID: number;
  // elapsedTime: string | null;
  clientId: number;
  departmentId: number;
  modelVersion: string | null;
  fromDate: string | null;
  toDate: string | null;
  fieldID: number;
  reportName: string | null;
  pageCount: number;
  taggingStatusID: number;
  processedCount: number;
  exceptionCount: number;
  isDigitized: boolean;
  engineName: string;
  completedFieldCount: number;
  docFieldCount: number;
  totalFieldCount: number;
  percent: number;
  isReprocessEnable: boolean;
  subRows?: BathcFileDetailsTypesWithSubRows[];
}

export enum ReviewDocumentStatusType {
  READY = 'READY',
  UPLOADED = 'UPLOADED',
  PROCESSING = 'PROCESSING',
  QAINPROGRESS = 'QAINPROGRESS',
  INTERRUPTED = 'INTERRUPTED',
  INPROGRESS = 'INPROGRESS',
  COMPLETED = 'COMPLETED',
  VERIFIED = 'VERIFIED',
  EXPORTED = 'EXPORTED',
  CURATIONINPROGRESS = 'CURATIONINPROGRESS',
  CURATIONINCOMPLETE = 'CURATIONINCOMPLETE',
  'API-INTERRUPTED' = 'API-INTERRUPTED',

  AUTOQC = 'AUTOQC',
  YETTOSTART = 'YETTO START',
  READYFORQC = 'READYFORQC',
  QCINCOMPLETE = 'QCINCOMPLETE',
  QCINPROGRESS = 'QCINPROGRESS',
  QCVERIFIED = 'QCVERIFIED',
  EXCEPTION = 'EXCEPTION',
  INITIATED = 'INITIATED',
  INQUEUE = 'IN-QUEUE', // Added
  VOLUMEEXCEEDED = 'VOLUMEEXCEEDED', // Added
  LOWDISKSPACE = 'LOWDISKSPACE', // Added
  READYFORCURATION = 'READYFORCURATION',
  READY_FOR_TRAINING = 'READYFORTRAINING',
  CURATIONCOMPLETED = 'CURATIONCOMPLETED',
  QCINTERRUPTED = 'QCINTERRUPTED'
}

export type ReviewDocumentStatusTypes = (typeof ReviewDocumentStatusType)[keyof typeof ReviewDocumentStatusType];

export interface BatchStatusListTypes {
  lookbackuptime: number;
  requestID: number;
  batchid: number;
  batchStatus: string;
  pageCount: number;
  isDigitized: true;
  completedFieldCount: number;
  docFieldCount: number;
  fileCount: number;
  processedCount: number;
  exceptionCount: number;
  totalFieldCount: number;
  percent: number;
}

export const AssurancePredictionStatusNameKeys = {
  [ReviewDocumentStatusType.READY]: 'elements.buttons.ready',
  [ReviewDocumentStatusType.UPLOADED]: 'pages.review.prediction.labels.uploaded',
  [ReviewDocumentStatusType.PROCESSING]: 'pages.review.prediction.labels.processing',
  [ReviewDocumentStatusType.QAINPROGRESS]: 'pages.review.prediction.labels.qaInProgress',
  [ReviewDocumentStatusType.INTERRUPTED]: 'pages.review.prediction.labels.interrupted',
  [ReviewDocumentStatusType.INPROGRESS]: 'pages.review.prediction.labels.inProgress',
  [ReviewDocumentStatusType.COMPLETED]: 'pages.review.prediction.labels.completed',
  [ReviewDocumentStatusType.VERIFIED]: 'pages.review.prediction.labels.verified',
  [ReviewDocumentStatusType.EXPORTED]: 'pages.review.prediction.labels.exported',
  [ReviewDocumentStatusType.CURATIONINPROGRESS]: 'pages.review.prediction.labels.curationInProgress',
  [ReviewDocumentStatusType.CURATIONINCOMPLETE]: 'pages.review.prediction.labels.curationInComplete',
  [ReviewDocumentStatusType['API-INTERRUPTED']]: 'pages.review.prediction.labels.apiInterrupted',
  [ReviewDocumentStatusType.AUTOQC]: 'pages.review.prediction.labels.autoQC',
  [ReviewDocumentStatusType.YETTOSTART]: 'pages.review.prediction.labels.yetToStart',
  [ReviewDocumentStatusType.READYFORQC]: 'elements.buttons.readyForQc',
  [ReviewDocumentStatusType.QCINPROGRESS]: 'pages.review.prediction.labels.qcInProgress',
  [ReviewDocumentStatusType.QCINCOMPLETE]: 'pages.review.prediction.labels.qcIncomplete',
  [ReviewDocumentStatusType.QCVERIFIED]: 'pages.review.prediction.labels.qcVerified',
  [ReviewDocumentStatusType.EXCEPTION]: 'pages.review.prediction.labels.exception',
  [ReviewDocumentStatusType.INITIATED]: 'pages.review.prediction.labels.initiated',
  [ReviewDocumentStatusType.INQUEUE]: 'pages.review.prediction.labels.inQueue',
  [ReviewDocumentStatusType.VOLUMEEXCEEDED]: 'pages.review.prediction.labels.volumeExceeded',
  [ReviewDocumentStatusType.LOWDISKSPACE]: 'pages.review.prediction.labels.lowDiskSpace'
};
export const ButtonLangKeys: any = {
  [ReviewDocumentStatusType.READY]: 'elements.buttons.ready',
  [ReviewDocumentStatusType.UPLOADED]: 'pages.review.prediction.labels.uploaded',
  [ReviewDocumentStatusType.PROCESSING]: 'pages.review.prediction.labels.processing',
  [ReviewDocumentStatusType.QAINPROGRESS]: 'pages.review.prediction.labels.qaInProgress',
  [ReviewDocumentStatusType.INTERRUPTED]: 'pages.review.prediction.labels.qcinterrupted',
  [ReviewDocumentStatusType.INPROGRESS]: 'pages.review.prediction.labels.inProgress',
  [ReviewDocumentStatusType.COMPLETED]: 'pages.review.prediction.labels.completed',
  [ReviewDocumentStatusType.VERIFIED]: 'pages.review.prediction.labels.verified',
  [ReviewDocumentStatusType.EXPORTED]: 'pages.review.prediction.labels.exported',
  [ReviewDocumentStatusType.CURATIONINPROGRESS]: 'pages.review.prediction.labels.curationInProgress',
  [ReviewDocumentStatusType.CURATIONINCOMPLETE]: 'pages.review.prediction.labels.curationInComplete',
  [ReviewDocumentStatusType['API-INTERRUPTED']]: 'pages.review.prediction.labels.apiInterrupted',
  [ReviewDocumentStatusType.AUTOQC]: 'pages.review.prediction.labels.autoQC',
  [ReviewDocumentStatusType.YETTOSTART]: 'pages.review.prediction.labels.yetToStart',
  [ReviewDocumentStatusType.READYFORQC]: 'elements.buttons.readyForQc',
  [ReviewDocumentStatusType.QCINPROGRESS]: 'pages.review.prediction.labels.qcInProgress',
  [ReviewDocumentStatusType.QCINCOMPLETE]: 'pages.review.prediction.labels.qcIncomplete',
  [ReviewDocumentStatusType.QCVERIFIED]: 'pages.review.prediction.labels.qcVerified',
  [ReviewDocumentStatusType.EXCEPTION]: 'pages.review.prediction.labels.exception',
  [ReviewDocumentStatusType.INITIATED]: 'pages.review.prediction.labels.initiated',
  [ReviewDocumentStatusType.INQUEUE]: 'pages.review.prediction.labels.inQueue',
  [ReviewDocumentStatusType.VOLUMEEXCEEDED]: 'pages.review.prediction.labels.volumeExceeded',
  [ReviewDocumentStatusType.LOWDISKSPACE]: 'pages.review.prediction.labels.lowDiskSpace',
  [ReviewDocumentStatusType.READYFORCURATION]: 'pages.review.verification.status.readyForCuration',
  [ReviewDocumentStatusType.CURATIONCOMPLETED]: 'pages.review.verification.status.curationCompleted'
};
